export default __webpack_public_path__ + "static/Gilroy-ExtraBold-018c7f6d78b411c5f5001a7296809b81.woff2";